import {ChangeDetectorRef, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {IModel} from "../../../../shared/view-model/imodel.interface";
import {map} from "rxjs/operators";
import {AbstractVisbosComponent} from "../../../../core/visbos-core/components/abstract-visbos.component";
import {AdministrationUnitService} from "../../../../organization/services/administration_unit_service/administration-unit.service";
import {Observable} from "rxjs/Observable";
import {SessionActions} from "../../../../shared/actions";
import {Depot} from "../../../../shared/view-model/store-management/depot.type";

@Component({
  selector: 'vb-touch-depot-needs-depot-selection',
  templateUrl: './touch-depot-needs-depot-selection.component.html',
  styleUrls: ['./touch-depot-needs-depot-selection.component.css']
})
export class TouchDepotNeedsDepotSelectionComponent extends AbstractVisbosComponent implements OnInit {

  managedDepots$: Observable<Depot[]>;
  selectedDepot: Depot;

  @Output()
  depotSelected: EventEmitter<Depot> = new EventEmitter<Depot>();

  depotLabel: (item: IModel) => string = (depot: Depot) => {
    let label = "";
    if (depot.administration_unit) {
      label = depot.administration_unit.label + ", ";
    }
    label += depot.label;
    return label;
  };

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private adminUnitService: AdministrationUnitService) {
    super(sessionActions, cd);
  }


  ngOnInit(): void {
    super.ngOnInit();

    this.managedDepots$ = this.adminUnitService.getAdminUnitDetails().pipe(
      map(res => res.data.fetchAdminUnits[0].depots_managed_by_external_admin_unit)
    );

  }

  onDepotSelected(depot: Depot) {
    this.selectedDepot = depot;
    this.depotSelected.emit(depot);
  }

}


// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/ui/touch-depot-needs/touch-depot-needs-depot-selection/touch-depot-needs-depot-selection.component.ts